import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'modules/auth/context';
import { PlanCheckoutModal } from 'components/portal/PlanCheckoutModal';
import { PublicTestsCatalog } from './PublicTestsCatalog';
import { PortalHeading } from './PortalHeading';
import { PortalPaymentReturn } from 'components/portal/PortalPaymentReturn';
import { PortalRenewalBanner } from 'components/portal/PortalRenewalBanner';
import { usePortalSubscription } from 'modules/portal-plans/usePortalSubscription';

export default function TestsCatalog() {
  const { t } = useTranslation();
  const { state, methods } = useAuthContext();
  const [params, setParams] = useSearchParams();
  const { data: subscription } = usePortalSubscription();
  const [renewalModalOpen, setRenewalModalOpen] = useState(false);
  const plan = params.get('plan');
  const paymentOrder = params.get('paymentOrder');
  const selectedPlan = plan === 'START' || plan === 'PRO' || plan === 'PREMIUM' ? plan : null;

  const closeCheckout = () => {
    setParams(previous => {
      const next = new URLSearchParams(previous);
      next.delete('plan');
      return next;
    }, { replace: true });
  };

  return (
    <div className="flex flex-col gap-5">
      <PortalHeading title={t('portal.tests')} description={t('portal.tests_description')} />
      {paymentOrder && <PortalPaymentReturn orderId={paymentOrder} onBalance={balanceSom => {
        methods.setUser(user => (user ? { ...user, balanceSom } : user));
      }} onDismiss={() => {
        setParams(previous => {
          const next = new URLSearchParams(previous);
          next.delete('paymentOrder');
          return next;
        }, { replace: true });
      }} />}
      <PortalRenewalBanner
        subscription={subscription}
        onRenew={() => setRenewalModalOpen(true)}
      />
      <PublicTestsCatalog userBalance={state.user?.balanceSom ?? 0} />
      {selectedPlan && (
        <PlanCheckoutModal
          open
          onOpenChange={open => { if (!open) closeCheckout(); }}
          defaultPlan={selectedPlan}
          subscription={subscription}
        />
      )}
      {renewalModalOpen && (
        <PlanCheckoutModal
          open={renewalModalOpen}
          onOpenChange={setRenewalModalOpen}
          defaultPlan={
            subscription?.planKey === 'START' || subscription?.planKey === 'PREMIUM'
              ? subscription.planKey
              : 'PRO'
          }
          subscription={subscription}
        />
      )}
    </div>
  );
}
